import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AdminLayout } from '../../components/layouts/AdminLayout';
import { AdminGuard } from '../../components/guards';

/**
 * Admin section layout route
 * Protected by AdminGuard - only accessible to admins
 */
export const Route = createFileRoute('/_authenticated/admin')({
  component: AdminRoute,
});

function AdminRoute() {
  return (
    <AdminGuard>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </AdminGuard>
  );
}
